/**
 * Above this many photos the editable grid is windowed: only the rows in view
 * (plus a little overscan) are mounted. Below it the grid renders exactly as
 * it always did. A 1,000-photo pick used to build 1,000 <img> nodes and
 * re-render all of them on every change, which on a phone, and inside the
 * Facebook app's WebView in particular, could freeze or kill the tab.
 */
export const VIRTUALIZE_AFTER = 60;

/** Same visible height as the plain grid's two-row maxHeight. */
export const GRID_VIEWPORT_HEIGHT = 180 * 2 + 16;

/** Narrow screens show three photos per row, as the plain grid does. */
export function photoGridLayout(width: number): {
  columnCount: number;
  columnWidth: number;
  rowHeight: number;
} {
  const narrow = width < 600;
  const columnCount = narrow ? 3 : Math.max(1, Math.floor(width / 132));
  return {
    columnCount,
    columnWidth: Math.max(1, Math.floor(width / columnCount)),
    // 100px photo + count controls + the plain grid's padding (xs 4px, sm 16px).
    rowHeight: narrow ? 144 : 168,
  };
}
